import { isArray, isObject } from "lodash";
function isDraftContent(content) {
  return isArray(content.blocks) && isObject(content.entityMap);
}
function isRichContent(content) {
  return isArray(content.nodes);
}
export {
  isDraftContent,
  isRichContent
};
//# sourceMappingURL=contentTypes.js.map
